import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CertificadosService } from 'src/app/services/certificados.service';
var CertificadosComponent = /** @class */ (function () {
    function CertificadosComponent(_router, _userService, _CertificadosService) {
        this._router = _router;
        this._userService = _userService;
        this._CertificadosService = _CertificadosService;
    }
    CertificadosComponent.prototype.ngOnInit = function () {
        if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
            this._router.navigate(['/']);
        }
        else {
            this.identity = this._userService.getIdentity();
            this.token = this._userService.getToken();
        }
    };
    return CertificadosComponent;
}());
export { CertificadosComponent };
